/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HubAchievementResponse } from './HubAchievementResponse';
import {
    HubAchievementResponseFromJSON,
    HubAchievementResponseFromJSONTyped,
    HubAchievementResponseToJSON,
    HubAchievementResponseToJSONTyped,
} from './HubAchievementResponse';

/**
 * 
 * @export
 * @interface DropAchievementListResponse
 */
export interface DropAchievementListResponse {
    /**
     * 
     * @type {Array<HubAchievementResponse>}
     * @memberof DropAchievementListResponse
     */
    achievements: Array<HubAchievementResponse>;
}

/**
 * Check if a given object implements the DropAchievementListResponse interface.
 */
export function instanceOfDropAchievementListResponse(value: object): value is DropAchievementListResponse {
    if (!('achievements' in value) || value['achievements'] === undefined) return false;
    return true;
}

export function DropAchievementListResponseFromJSON(json: any): DropAchievementListResponse {
    return DropAchievementListResponseFromJSONTyped(json, false);
}

export function DropAchievementListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropAchievementListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'achievements': ((json['achievements'] as Array<any>).map(HubAchievementResponseFromJSON)),
    };
}

export function DropAchievementListResponseToJSON(json: any): DropAchievementListResponse {
    return DropAchievementListResponseToJSONTyped(json, false);
}

export function DropAchievementListResponseToJSONTyped(value?: DropAchievementListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'achievements': ((value['achievements'] as Array<any>).map(HubAchievementResponseToJSON)),
    };
}

